

<p-confirmDialog />

<div class="plan-page-container">
  <div class="plan-page-header">
    <h3 class="m-0">RAID</h3>
    <p-button
      label="Add"
      icon="pi pi-plus"
      (onClick)="showAddItemDialog()"
      severity="info"
      [rounded]="true" />
  </div>

  <p-table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="items"
    [loading]="loading"
    [paginator]="items.length > 10"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 20, 50]"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="p-datatable no-column-lines compact-striped-table table-scroll-both raid-table">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-num">#</th>
        <th pSortableColumn="type" class="col-type">
          <span>Type</span>
          <p-sortIcon field="type" />
        </th>
        <th class="col-description">Description</th>
        <th class="col-date">Identified Date</th>
        <th pSortableColumn="impact" class="col-impact">
          <span>Impact</span>
          <p-sortIcon field="impact" />
        </th>
        <th class="col-owner">Owner</th>
        <th class="col-date">Target Date</th>
        <th pSortableColumn="status" class="col-status">
          <span>Status</span>
          <p-sortIcon field="status" />
        </th>
        <th class="col-mitigation">Mitigation Plan</th>
        <th class="col-date">Date closed</th>
        <th class="col-remark">Remark</th>
        <th class="th-actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td class="cell-num">{{ item.itemNumber }}</td>
        <td class="cell-type">{{ item.type }}</td>
        <td class="td-truncate td-description cell-description" [pTooltip]="item.description || '-'" tooltipPosition="top" [escape]="false">{{ item.description || '-' }}</td>
        <td class="cell-date">{{ formatDate(item.identifiedDate) }}</td>
        <td class="cell-impact">
          <p-tag
            [value]="item.impact"
            [severity]="getImpactSeverity(item.impact)" />
        </td>
        <td class="cell-owner">{{ item.owner }}</td>
        <td class="cell-date">{{ formatDate(item.targetDate) }}</td>
        <td class="cell-status">
          <p-tag
            [value]="item.status"
            [severity]="getStatusSeverity(item.status)" />
        </td>
        <td class="td-truncate td-description cell-mitigation" [pTooltip]="(item.mitigationPlan || '-')" tooltipPosition="top" [escape]="false">{{ item.mitigationPlan || '-' }}</td>
        <td class="cell-date">{{ formatDate(item.dateClosed) }}</td>
        <td class="td-truncate td-description cell-remark" [pTooltip]="(item.remark || '-')" tooltipPosition="top" [escape]="false">{{ item.remark || '-' }}</td>
        <td class="table-cell-actions">
          <div class="table-actions-stack">
            <p-button
              icon="pi pi-pencil"
              (onClick)="showEditItemDialog(item)"
              [text]="true"
              severity="info"
              size="small"
              pTooltip="Edit"
              tooltipPosition="top" />
            <p-button
              icon="pi pi-trash"
              (onClick)="deleteItem(item)"
              [text]="true"
              severity="danger"
              size="small"
              pTooltip="Delete"
              tooltipPosition="top" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="12" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No RAID items found</p>
            <p class="empty-description">Click "Add" to create a new RAID item</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Item Dialog -->
<p-dialog
  [visible]="displayItemDialog"
  (visibleChange)="displayItemDialog = $event"
  [header]="isEditItemMode ? 'Edit RAID Item' : 'Add RAID Item'"
  [modal]="true"
  [style]="{width: '95vw', maxWidth: '1200px'}"
  [dismissableMask]="true"
  [closable]="true">
  
  <div *ngIf="selectedItem" class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field">
          <label for="itemNumber">Item Number</label>
          <input
            pInputText
            id="itemNumber"
            [value]="selectedItem.itemNumber"
            readonly
            class="readonly-field" />
        </div>
        <div class="field">
          <label for="type">Type <span class="required-star">*</span></label>
          <p-select
            id="type"
            [(ngModel)]="selectedItem.type"
            [options]="typeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select type"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body"
            styleClass="w-full" />
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="impact">Impact <span class="required-star">*</span></label>
          <p-select
            id="impact"
            [(ngModel)]="selectedItem.impact"
            [options]="impactOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select impact"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body"
            styleClass="w-full" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['owner'] && !selectedItem.owner.trim()">
          <label for="owner">Owner <span class="required-star">*</span></label>
          <input
            pInputText
            id="owner"
            [(ngModel)]="selectedItem.owner"
            placeholder="Enter owner name"
            required
            class="w-full"
            (blur)="fieldTouched['owner'] = true" />
          <small class="field-error" *ngIf="fieldTouched['owner'] && !selectedItem.owner.trim()">Owner is required</small>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="identifiedDate">Identified Date <span class="required-star">*</span></label>
          <p-datepicker
            id="identifiedDate"
            [(ngModel)]="identifiedDate"
            [showIcon]="true"
            dateFormat="D, M d, yy"
            placeholder="Select date"
            [showButtonBar]="true"
            appendTo="body"
            [showOnFocus]="false"
            [autoZIndex]="true"
            styleClass="w-full" />
        </div>
        <div class="field">
          <label for="targetDate">Target Date</label>
          <p-datepicker
            id="targetDate"
            [(ngModel)]="targetDate"
            [showIcon]="true"
            dateFormat="D, M d, yy"
            placeholder="Select date"
            [showButtonBar]="true"
            appendTo="body"
            [showOnFocus]="false"
            [autoZIndex]="true"
            styleClass="w-full" />
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="dateClosed">Date Closed</label>
          <p-datepicker
            id="dateClosed"
            [(ngModel)]="dateClosed"
            [showIcon]="true"
            dateFormat="D, M d, yy"
            placeholder="Select date"
            [showButtonBar]="true"
            appendTo="body"
            [showOnFocus]="false"
            [autoZIndex]="true"
            styleClass="w-full" />
        </div>
        <div class="field">
          <label for="status">Status <span class="required-star">*</span></label>
          <p-select
            id="status"
            [(ngModel)]="selectedItem.status"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select status"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body"
            styleClass="w-full"
            [ngClass]="'status-' + getStatusSeverity(selectedItem.status || '')">
            <ng-template let-option pTemplate="item">
              <div class="dropdown-item-content">
                <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              <div class="dropdown-selected-content">
                <span class="status-badge" [ngClass]="'status-' + getStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>

      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['description'] && !selectedItem.description.trim()">
          <label for="description">Description <span class="required-star">*</span></label>
          <textarea
            pInputText
            id="description"
            [(ngModel)]="selectedItem.description"
            rows="3"
            placeholder="Enter description..."
            required
            (blur)="fieldTouched['description'] = true"></textarea>
          <small class="field-error" *ngIf="fieldTouched['description'] && !selectedItem.description.trim()">Description is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="mitigationPlan">Mitigation Plan</label>
          <textarea
            pInputText
            id="mitigationPlan"
            [(ngModel)]="selectedItem.mitigationPlan"
            rows="3"
            placeholder="Enter mitigation plan..."></textarea>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="remark">Remark</label>
          <textarea
            pInputText
            id="remark"
            [(ngModel)]="selectedItem.remark"
            rows="3"
            placeholder="Enter remark..."></textarea>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button
        label="Reset"
        icon="pi pi-refresh"
        (onClick)="resetItemForm()"
        [text]="true"
        severity="secondary"
        styleClass="btn-form-reset" />
      <p-button
        label="Cancel"
        icon="pi pi-times"
        (onClick)="displayItemDialog = false"
        severity="secondary"
        [outlined]="true" />
      <p-button
        label="Save"
        icon="pi pi-check"
        (onClick)="saveItem()"
        severity="primary"
        [disabled]="!selectedItem || !selectedItem.description.trim() || !selectedItem.owner.trim()" />
    </div>
  </ng-template>
</p-dialog>

